module.exports = __webpack_public_path__ + "img/ctrl-p-stub-down-1.b9258a64.svg";